 
import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.iconName = "checkmark-circle";
config.viewBox="0 0 18 18"
config.shape = `
   <g stroke="var(--stroke)" stroke-width="2px" fill="var(--fill)" fill-rule="evenodd">
        <ellipse stroke="var(--stroke-ellipse)" fill="var(--fill-elipse)" cx="8" cy="8" rx="7" ry="7"></ellipse>
        <polyline stroke="var(--stroke-polyline)" stroke-width="var(--stroke-width-polyline)" points="3 8.45629883 7.30163574 11.2969971 12.4187622 4.5"></polyline>
    </g>`;

let CheckmarkCircleSVG = new SvgFactory(config);

export default CheckmarkCircleSVG;
